<template>
  <div class="pagebar">
    <ul class="mypager" :class="alignCls">
      <li>
        <a href="javascript:void(0);" class="pg__prev" :class="{disabled:currentPage===1}" @click="prevPage">
          <span>&laquo;</span>
        </a>
      </li>
      <li v-for="item in pageList" :key="item">
        <a v-if="item" href="javascript:void(0);" :class="{active: item === currentPage}" @click="pageOffset(item)">{{item}}</a>
        <span v-else class="ellipse">...</span>
        </li>
      <li>
        <a href="javascript:void(0);" class="pg__next" :class="{disabled:currentPage===pageCount || count === 0}" @click="nextPage">
          <span>&raquo;</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  const integerValidator = (val) => {
    return /^[1-9][0-9]{0,}$/.test(val)
  }

  export default {
    props: {
      align: {
        type: String,
        default: 'center'
      },
      count: {
        type: Number,
        default: 0
      },
      pageSize: {
        type: Number,
        default: 1,
        validator: integerValidator
      },
      currentPage: {
        type: Number,
        default: 1,
        validator: integerValidator
      }
    },
    data () {
      return {}
    },
    computed: {
      alignCls () {
        let cls = {
          left: 'text-left',
          center: 'text-center',
          right: 'text-right'
        }
        return cls[this.align]
      },
      /**
       * 总共多少页
       * @returns {number}
       */
      pageCount () {
        return Math.ceil(this.count / this.pageSize)
      },
      /**
       * 页码
       * @returns {Array}
       */
      pageList () {
        let pageNum = this.pageCount
        let index = this.currentPage
        let arr = []
        if (pageNum <= 5) {
          for (let i = 1; i <= pageNum; i++) {
            arr.push(i)
          }
          return arr
        }
        if (index <= 2) return [1, 2, 3, 0, pageNum]
        if (index >= pageNum - 1) return [1, 0, pageNum - 2, pageNum - 1, pageNum]
        if (index === 3) return [1, 2, 3, 4, 0, pageNum]
        if (index === pageNum - 2) return [1, 0, pageNum - 3, pageNum - 2, pageNum - 1, pageNum]
        return [1, 0, index - 1, index, index + 1, 0, pageNum]
      }
    },
    methods: {
      pageOffset (i) {
        if (i === 0 || i === this.currentPage) return
        this.$emit('on-page-click', i)
      },
      prevPage () {
        if (this.currentPage > 1) {
          this.$emit('on-page-click', this.currentPage - 1)
        }
      },
      nextPage () {
        if (this.currentPage !== this.pageCount && this.count !== 0) {
          this.$emit('on-page-click', this.currentPage + 1)
        }
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  .pagebar
    .mypager
      list-style none
      padding 0
      margin 0
      font-size 0
      li
        display inline-block
        font-size 12px
        text-align center
        margin 0 6px
        vertical-align middle
      a,.ellipse
        display inline-block
        width 40px
        height 40px
        color #000
        line-height 40px
        text-decoration none
        border 1px solid rgb(229, 229, 229)
        background-color #fff
        border-radius 2px
      a:hover, a.active
          color #a03024
          background-color rgb(238, 238, 238)
      .pg__prev, .pg__next
        font-size 18px
      .disabled, .disabled:hover
        cursor not-allowed
        color #999
        background-color rgba(238, 238, 238, 0.5)
</style>



// WEBPACK FOOTER //
// pagination.vue?725585e2